import {translation} from "@2d-front-monorepo/core";
import React, {JSX, memo} from "react";
import {reservationStatusLabel, reservationStatusName} from "../helpers/enumNaming";
import {PaymentStatus, ReservationResult} from "../index";
import PaymentStatusComponent from "./PaymentStatusComponent";

function ReservationStatusComponent({reservation}: { reservation: ReservationResult }): JSX.Element {
	const paymentStatus = reservation.payment?.status;
	const reservationStatus = reservation.status.type;

	if (paymentStatus == PaymentStatus.Void) {
		return <PaymentStatusComponent payment={reservation.payment}/>
	}

	const pillClass = `pill pill__reservation-status--${reservationStatusName(reservationStatus)}`;
	return (<div className={pillClass}>{translation(reservationStatusLabel(reservationStatus))}</div>);
}

const MemoizedReservationStatusComponent: React.FC<{
	reservation: ReservationResult
}> = memo(ReservationStatusComponent);
export default MemoizedReservationStatusComponent;
